import { useCallback, useState } from "react";

import useRouteHandler from "../../hooks/route/useRouteHandler";

import "./routedashboard.css";
import RouteMap from "./RouteMap";
import RouteBuilder from "./RouteBuilder";
import RouteSummary from "./RouteSummary";

const RouteDashboard = () => {
  const [mapInstance, setMapInstance] = useState(null);

  const {
    routeDraft,
    setRouteDraft,
    waypointDraft,
    selectingPoint,

    setRouteName,
    setRouteDescription,
    setWaypointName,
    setWaypointAddress,
    setWaypointWaitingSeconds,

    startPointSelection,
    handleMapPoint,
    addWaypoint,
    removeWaypoint,

    normalizeValhallaRoute,
  } = useRouteHandler();

  const handleMapReady = useCallback((map) => {
    setMapInstance(map);
  }, []);

  const handleMapClick = useCallback(
    (event) => {
      const { lng, lat } = event.lngLat;
      handleMapPoint(lng, lat);

      console.log("Route map clicked: ", { lng, lat });
    },
    [handleMapPoint],
  );

  return (
    <div className="route-dashboard-container">
      <div className="route-dashboard-map">
        <RouteMap
          onMapReady={handleMapReady}
          onMapClick={handleMapClick}
          waypoints={routeDraft.waypoints}
          route={routeDraft.route}
        />
      </div>

      <RouteBuilder
        routeDraft={routeDraft}
        setRouteDraft={setRouteDraft}
        waypointDraft={waypointDraft}
        selectingPoint={selectingPoint}
        onRouteNameChange={setRouteName}
        onRouteDescriptionChange={setRouteDescription}
        onWaypointNameChange={setWaypointName}
        onWaypointAddressChange={setWaypointAddress}
        onSelectPoint={startPointSelection}
        onAddWaypoint={addWaypoint}
        onRemoveWaypoint={removeWaypoint}
        normalizeValhallaRoute={normalizeValhallaRoute}
      />

      <RouteSummary routeDraft={routeDraft} waypoints={routeDraft.waypoints} />
    </div>
  );
};

export default RouteDashboard;
